(ns practitest.frontend.components2.confirmation-modal
  (:require
   [practitest.frontend.components.icons :as icons]
   [practitest.frontend.components.modal :as modal]
   [practitest.frontend.components2.buttons :as buttons]))

(defn confirmation-modal [{:keys [show? show-footer? show-icon?
                                  title
                                  on-confirm on-cancel
                                  confirmation-button-text
                                  cancel-button-text
                                  confirm-disabled?
                                  confirm-end-icon
                                  cancel-disabled?
                                  modal-class
                                  container-ref
                                  dialog-test-id
                                  confirm-test-id]
                           :or   {show?        true
                                  show-footer? true
                                  show-icon?   true}}
                          body]
  [:<>
   [modal/bootstrap-modal
    {:class            modal-class
     :is-open?         show?
     :container-ref    container-ref
     :on-request-close on-cancel
     :close-button?    true
     :centered?        true
     :footer-class     "justify-content-center"
     :title-class      "justify-content-center"
     :test-id          dialog-test-id}
    [:<>
     (when show-icon?
       [icons/mux-notification-error])
     [:p title]]
    body
    (when show-footer?
      [:<>
       (when cancel-button-text
         [buttons/button {:size      "large"
                          :disabled? cancel-disabled?
                          :on-click  on-cancel
                          :text      cancel-button-text}])
       (when confirmation-button-text
         [buttons/button {:primary?  true
                          :size      "large"
                          :class     "btn-delete"
                          :disabled? confirm-disabled?
                          :end-icon  confirm-end-icon
                          :on-click  on-confirm
                          :test-id   confirm-test-id
                          :text      confirmation-button-text}])])]])
